// extracted by mini-css-extract-plugin
export default {"wrapper":"SuspensePlaceholder_wrapper__ywxKJ"};